<script setup lang="ts">
import { provide } from 'vue'
import UiNav from '@/components/UiNavigation/UiNav/UiNav.vue'
import UiNavMobile from '@/components/UiNavigation/UiNavMobile/UiNavMobile.vue'
import UiHamburger from '@/components/UiNavigation/UiHamburger/UiHamburger.vue'
import navigation, { MOBILE_NAVIGATION } from '@/data/navigation'

interface IProps {
  hideLang?: boolean;
  sticking: boolean;
}

const { hideLang, sticking: stickingProp } = defineProps<IProps>()

const { appURL } = useRuntimeConfig().public
const { isTrueDesktop } = useBSBreakpoints()
const { locale } = useI18n()

const target = ref()
const sticking = ref(stickingProp || false)
const isMobileMenuOpen = ref(false)

const toggleMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

provide('hideLang', hideLang)

onMounted(() => {
  if (typeof window !== 'undefined') {
    const observer = new IntersectionObserver(
      ([entry]) => {
        sticking.value = stickingProp || !entry.isIntersecting
      },
      { threshold: 0.0 },
    )
    observer.observe(target.value)
  }
})
</script>

<template>
  <div ref="target" />
  <header
    :class="[
      'navigation',
      { 'is-open': isMobileMenuOpen },
      { sticking }
    ]"
  >
    <div class="navigation__content">
      <NuxtLink
        :to="`${appURL}${locale === 'en' ? '/en' : ''}`"
        title="Benefit Logo"
        aria-label="Benefit Logo"
      >
        <img
          src="/logo.svg"
          class="navigation__logo"
        >
      </NuxtLink>

      <UiNav
        v-if="isTrueDesktop"
        :navigation="navigation"
      />

      <UiNavMobile
        v-if="!isTrueDesktop"
        :is-open="isMobileMenuOpen"
        :navigation="MOBILE_NAVIGATION"
        @toggle-menu="isMobileMenuOpen = false"
      />

      <UiHamburger
        v-if="!isTrueDesktop"
        :is-open="isMobileMenuOpen"
        @click="toggleMenu"
      />
    </div>
  </header>
</template>

<style lang="scss" scoped>
.navigation {
  position: fixed;
  z-index: 99;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: transparent;

  &.is-open,
  &.sticking {
    background-color: $white;
    transition: all .5s ease-in-out;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 156rem;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2.4rem;
    padding-left: 2.4rem;
  }

  &__logo {
    width: 9.6rem;
    height: auto;

    @include atM {
      width: 13.2rem;
    }
  }
}
</style>
